












































import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { IDelegate, ISortParameters } from "@/interfaces";
import { MonitorHeader, ForgingStats } from "@/components/monitor";
import DelegateService from "@/services/delegate";

@Component({
  components: {
    MonitorHeader,
    ForgingStats,
  },
  computed: {
    ...mapGetters("network", ["height", "activeDelegates"]),
  },
})
export default class DelegateMonitor extends Vue {
  private delegates: IDelegate[] | null = null;
  private activeTab = "active";
  private height: number;

  get sortParams() {
    return this.$store.getters["ui/delegateSortParams"];
  }

  set sortParams(params: ISortParameters) {
    this.$store.dispatch("ui/setDelegateSortParams", {
      ...this.sortParams,
      [this.activeTab]: {
        field: params.field,
        type: params.type,
      },
    });
  }

  @Watch("height")
  public async onHeightChanged() {
    await this.setDelegates();
  }

  @Watch("activeTab")
  public async onActiveTabChanged() {
    this.delegates = null;
    await this.setDelegates();
  }

  public async created() {
    await this.setDelegates();
  }

  private async setDelegates() {
    if (this.height) {
      // @ts-ignore
      this.delegates = await DelegateService[this.activeTab]();
    }
  }

  private onSortChange(params: ISortParameters) {
    this.sortParams = params;
  }
}
